import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import CustomerReportFilter from "./CustomerReportFilter";
import classes from "./index.module.css";
import { saveCustomer } from "../../services/customer-services";

import AddCustomer from "./addCustomer";
import CustomerReportSummary from "./CustomerReportSummary";
import { displayToast } from "../../framework/toast/toastUtils";

const Customer = () => {
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [customerRowEditData, setCustomerRowEditData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);

  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const lockRef = useRef();
  const refreshRef = useRef();

  const refreshData = useCallback((filterData = {}) => {
    reportRef.current.applyFilters(filterData);
  }, []);

  const addCustomer = useCallback((isEdit = false) => {
    if (isEdit) {
      setCustomerRowEditData(() => reportRef.current.getCurrentRowData());
    }
    setShowAddCustomer(true);
  }, []);
  const lockHandler = useCallback(async () => {
    if (!currentRowData) {
      console.error("No currentRowData available");
      return;
    }
    let savePatientObject = {};
    savePatientObject = {
      ...currentRowData.data,
      isLocked: !currentRowData?.data.isLocked,
    };
    const response = await saveCustomer(savePatientObject);
    if (response?.status === "success") {
      refreshData();
      displayToast({
        type: "success",
        title: savePatientObject.isLocked
          ? "Locked Successfully"
          : "Unlocked Successfully",
      });
    }
  }, [currentRowData, refreshData]);

  const closeProductAc = useCallback(() => {
    setShowAddCustomer(false);
    setCustomerRowEditData(null);
    setCurrentComponent("grid_reports");
    refreshRef.current.click();
  }, [setCurrentComponent]);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        refreshRef.current.click();
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (altKey && key === "l") {
        if (currentRowData?.data) lockRef.current.click();
        return;
      }
      if (altKey && key === "p") {
        return addCustomer();
      }
    },
    [addCustomer, currentRowData]
  );

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addCustomer(true);
        }}
        isAccessible={currentRowData}
      />,
      <Button
        ref={lockRef}
        startIcon={<Shortcut keys={["Alt", "L"]} />}
        label={currentRowData?.data.isLocked ? "Unlock" : "Lock"}
        onClick={() => {
          lockHandler();
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addCustomer, lockHandler, currentRowData]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddCustomer &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow, showAddCustomer]);

  useEffect(() => {
    refreshData({ isFilterChanged: true, ...filterStates });
  }, [refreshData, filterStates]);
  return (
    <div className={classes["customer-report-container"]}>
      <Reports
        identifier="customer"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
        // filterParams={filterParams}
        // filterStates={filterStates}
        filters={
          <CustomerReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            // refreshData={refreshData}
            // applyFilters={(params, filterStates) => {
            //   // refreshData(params);
            //   // setFilterParams(params);
            //   // setFilterStates(filterStates);
            // }}
            onFilterShow={onFilterShow}
          />
        }
      />
      <CustomerReportSummary
        refreshData={refreshData}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addCustomer();
        }}
      />
      <Autocomplete
        show={showAddCustomer}
        height="86%"
        width="90%"
        closeAutoComplete={closeProductAc}
      >
        <AddCustomer
          customerRowEditData={customerRowEditData}
          onEscape={closeProductAc}
          onSaveCustomer={closeProductAc}
        />
      </Autocomplete>
    </div>
  );
};

export default Customer;
